var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownCaret = function SvgDownCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 12,
    fill: "none",
    viewBox: "0 0 22 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#07C799",
    d: "M11 11.179.608.679h20.784z"
  })));
};
export { SvgDownCaret as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAyMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDExLjE3ODdMMC42MDc2OTYgMC42Nzg3MTNMMjEuMzkyMyAwLjY3ODcxMUwxMSAxMS4xNzg3WiIgZmlsbD0iIzA3Qzc5OSIvPgo8L3N2Zz4K";